export default "__VITE_ASSET__P17BlFDK__"